import * as  guid from "guid-typescript";
import moment from 'moment';


export const Guid: typeof guid.Guid = guid.Guid;

export function Log( lg: any )
{
    console.log( lg );
}

export function Wait( milliseconds: number )
{
    return new Promise( resolve => setTimeout( resolve, milliseconds ) );
}

export function WaitEntre( m1: number, m2: number )
{
    return new Promise( resolve => setTimeout( resolve, Random.Enteros(m1,m2) ) );
}


export function formatearCodigoArticulo( Codigo: string ): string
{
    if ( Codigo )
    {
        Codigo = Codigo.toUpperCase();
        Codigo = Codigo.borraLetras();
        Codigo = Codigo.eliminar( " " );
        Codigo = Codigo.eliminar( "/" );
        Codigo = Codigo.eliminar( "-" );
        Codigo = Codigo.eliminar( "_" );
        Codigo = Codigo.eliminar( ":" );
        Codigo = Codigo.padCeros( 6 );
        Codigo = Codigo.insertar( 5, "/" );
    }
    return Codigo;
}

class random
{

    protected get Auxiliar(): number { return Math.random(); }

    public Enteros( min: number, max: number ): number
    {
        let e = Math.floor( this.Auxiliar * ( max - min ) ) + min;
        return e;
    }

}
export const Random = new random();

export function getDropedFiles( e: any ): any[]
{

    let droppedFiles = e.dataTransfer.files;
    if ( !droppedFiles ) return;
    let files: any[] = [];
    ( [...droppedFiles] ).forEach( f =>
    {
        files.push( f );
    } );

    return files;

}

export function CopiarAlPortapapeles( acopiy: string )
{

    var aux = document.createElement( "input" );
    aux.setAttribute( "value", acopiy );
    document.body.appendChild( aux );
    aux.select();
    document.execCommand( "copy" );
    document.body.removeChild( aux );
}